import { render } from "./CardImageBG.vue?vue&type=template&id=5d99c620"
import script from "./CardImageBG.vue?vue&type=script&lang=js"
export * from "./CardImageBG.vue?vue&type=script&lang=js"

import "./CardImageBG.vue?vue&type=style&index=0&id=5d99c620&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__